<template>
  <v-dialog :value="true" scrollable max-width="560" @input="$emit('fechar')">
    <v-card>
      <v-card-title class="text-h6">
        <v-icon left>mdi-list-status</v-icon>
        Histórico de pagamentos
      </v-card-title>
      <v-card-subtitle class="pb-2">
        <div class="text-subtitle-1 font-weight-bold text--primary">{{ nomeDoAluno }}</div>
        <div>{{ preMatricula.turma ? preMatricula.turma.descricao : "—" }}</div>
      </v-card-subtitle>
      <v-divider />
      <v-card-text class="pt-4">
        <e-historico-de-pagamentos :parcela-id="preMatricula.parcela.id" />
      </v-card-text>
      <v-divider />
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="$emit('fechar')">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import EHistoricoDePagamentos from "./EHistoricoDePagamentos.vue";

/** Movimentações da parcela da pré-matrícula, somente leitura. */
export default {
  name: "EModalHistoricoDePagamentos",
  components: { EHistoricoDePagamentos },
  props: {
    preMatricula: { type: Object, required: true },
  },
  computed: {
    nomeDoAluno() {
      const { nome, aluno } = this.preMatricula;
      return nome || (aluno && aluno.nomecompleto) || "—";
    },
  },
};
</script>
